import React from "react";
import { Localized, useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";
import type OrganizationUser from "byzantine/src/OrganizationUser";

interface SaveRoleDialogProps {
  isOpen: boolean;
  roleName: string;
  /** The active team members assigned to the role (not pending invites). Their access changes as soon as the role is saved. */
  assignedUsers: OrganizationUser[];
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirms saving a role that has assigned team members, naming the user or showing the count. */
export default function SaveRoleDialog({
  isOpen,
  roleName,
  assignedUsers,
  onConfirm,
  onClose,
}: SaveRoleDialogProps) {
  const { l10n } = useLocalization();
  const count = assignedUsers.length;

  return (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={onClose}
      title={l10n.getString("org-role-save-dialog-title")}
      width="500px"
      footer={
        <Row alignItems="center" justifyContent="end">
          <Row.Item shrink>
            <Button
              kind="negative"
              label={l10n.getString("button-close")}
              onClick={onClose}
              testId="save-role-dialog-close"
            />
          </Row.Item>
          <Row.Item shrink>
            <Button
              label={l10n.getString("org-role-save-dialog-confirm")}
              onClick={onConfirm}
              testId="save-role-dialog-confirm"
            />
          </Row.Item>
        </Row>
      }
    >
      <Localized
        id="org-role-save-dialog-body"
        vars={{
          count,
          name: count === 1 ? assignedUsers[0].fullName() : "",
          role: roleName,
        }}
        elems={{ bold: <strong /> }}
      >
        <p />
      </Localized>
      <p className="margin--top--l">
        {l10n.getString("org-role-save-dialog-access")}
      </p>
    </Dialog>
  );
}
